export class UserProfilePasswordListener {
    public static bindSubmit(form: HTMLFormElement, onSubmit: (event: Event) => void): void {
        form.addEventListener("submit", onSubmit);
    }
}
